import "regenerator-runtime/runtime";

/**** To drive the Grid Card Functionality ****/
//Any changes done to this will also affect UCITS. Contact Eugene for any questions
$(_ => {

    //Guard - run only if there is an insights grid component on the page
    if ($(".ve-dynamic-related-media").length == 0) return;

    /*** veRelatedMedia = the roubust insights grid component designed to interface with the related media service */
    window.veRelatedMedia = {
        initialised: false,
        relatedMediaItems: [],
        endpoint: window.location.href + "/GetMediaWithPaging", //default endpoint to be overwritten by data attribute endpoint
        debug: false,
        shouldScrollIntoView: false,


        /**
         * Accepts the grid object and based on the data available, query the endpoint and obtain the media items.
         * @param {any} relatedMediaItem
         */
        getData: async relatedMediaItem => {
            veRelatedMedia.debug ? console.time("Retrieve Data for Related Media-" + relatedMediaItem.id) : false;
            try {
                const data = await $.post(relatedMediaItem.endpoint,
                    {
                        pageNumber: relatedMediaItem.nextPage,
                        pageSize: relatedMediaItem.count,
                        SiteContext: veRelatedMedia.getSiteContext(relatedMediaItem.siteContext),
                    }
                );

                veRelatedMedia.debug ? console.timeEnd("Retrieve Data for Related Media-" + relatedMediaItem.id) : false;

                veRelatedMedia.debug ? console.log(data) : false;

                veRelatedMedia.debug ? console.time("Render Items for Related Media-" + relatedMediaItem.id) : false;

                veRelatedMedia.drawRelatedMedia(relatedMediaItem, data);
            }
            catch (e) {
                veRelatedMedia.debug ? console.timeEnd("Retrieve Data for Related Media-" + relatedMediaItem.id) : false;
                console.log("Error occured while fetching Related Media Grid Data.");
                console.error(e);
            }

        },

        clearData: (relatedMediaItem) => {
            $(relatedMediaItem.element).find(".draw-area").empty();
            $(relatedMediaItem.element).find(".view-more").removeClass("hide").empty().show();
        },


        /**
         * Draws the related media item based on data obtained from the endpoint response.
         * Needs the data as well as the appropriate grid to be drawn.
         * @param {any} relatedMediaItem
         * @param {any} data
         */
        drawRelatedMedia: (relatedMediaItem, data) => {
            if (!data) return console.error("There is no data to render!");
            if (!relatedMediaItem) return console.error("There is no relatedMediaItem to render!");

            //now that we got the data, lets see if there is more pages and then increment the next page.
            if (data.Result.HasMoreItems) {
                veRelatedMedia.relatedMediaItems[relatedMediaItem.id].nextPage++;
                $(relatedMediaItem.element).find(".view-more").show();
            } else {
                $(relatedMediaItem.element).find(".view-more").hide();
            }

            var mkGrid = ""; //The markup for the entire grid component to be drawn, made of multiple insights items.
            var unformattedMessage = "";
            var formattedMessage = "";

            if (data.Result.FileInfos.length > 0) {
                data.Result.FileInfos.forEach((e, i) => {
                    mkGrid += veRelatedMedia.renderItem(e, relatedMediaItem.template ?? "au-landing-grid")
                })
            }
            else {
                const currentCategory = $("#NewsDropdown .dropdown__label").text().trim();
                const currentMediaType = $("#NewsTypeDropdown .dropdown__label").text().trim();
                var message = "";
                if (currentCategory && currentCategory != veDictionary.allInsights && currentMediaType && currentMediaType != veDictionary.allFormats) {
                    unformattedMessage = veDictionary.noCategoriesVisit;
                    formattedMessage = unformattedMessage.replace('{0}', currentCategory).replace('{1}', currentMediaType.toLowerCase()).replace('{2}', currentMediaType.toLowerCase());
                    //message += `Sorry, there are no ${currentCategory} ${currentMediaType.toLowerCase()} at this time. Come back and visit for future ${currentMediaType.toLowerCase()}.`;
                    message += formattedMessage;
                }
                else if (currentCategory && currentCategory != veDictionary.allInsights) {
                    unformattedMessage = veDictionary.noCategoriesAtThisTime;
                    formattedMessage.replace('{0}', currentCategory);
                    //message += `Sorry, there are no ${currentCategory} insights at this time.`;
                    message += formattedMessage;
                }
                else {
                    message += veDictionary.noCategories;
                }
                mkGrid += `<div class="text-center w-100"><p>${message}</p></div>`;
            }
            //iterate and render the elems


            //Draw the grid on the component and enable the view more button.
            $(relatedMediaItem.element).find(".draw-area").append(mkGrid);
            yall();
            $(relatedMediaItem.element).find(".view-more .btn-primary").attr("disabled", false);

            veRelatedMedia.debug ? console.timeEnd("Render Items for Related Media-" + relatedMediaItem.id) : false;
        },


        /**
         * Generates the markup for a signle related media media item, based on a template
         * @param {any} item
         * @param {any} template
         */
        renderItem: (item, template) => {
            var mkimage = item.ImageUrl ?
                `<div class="position-relative"><a data-ve-gtm="item-image" class="grid-card__image-link" href="${item.FileUrl}" target="_blank">
                                    <div class="grid-card__image-container mb-3 no-print">
                                      <div class="image grid-card__image lazy-bg lazy-bg-force" data-src="${item.ImageUrl}" style="padding-bottom:56.25%">
                                        <img alt="${item.Title}" class="image__img lazy" data-src="${item.ImageUrl}"></div>
                                    </div>
                                  </a></div>`
                : "";

            var mkDate = `<div data-ve-gtm="item-date" class="text-util-md">${item.FormattedPublishDate}</div>`

            var mkCategory = item.Subtitle ? `<div data-ve-gtm="item-category" class="text-util-md">${item.Subtitle}</div>` : "";

            var mksummary = `<div data-ve-gtm="item-abstract" class="grid-card__body">
                                 ${item.Description}
                                </div>`;

            switch (template) {

                /***
                 *  In future if other templates are required for the grid, we can add them here as another case.
                 **/
                case "landing-grid":
                    return `<div class="insights-grid__item col-md-6 col-lg-3">
                              <div data-ve-gtm="${veRelatedMedia.getGtmGridCardAttributeValue(item.Type)}" class="grid-card">
                                ${mkimage}
                                ${mkCategory}
                                <div class="grid-card__header"><a data-ve-gtm="item-title" class="grid-card__title-link" href="${item.MediaLink}">
                                    <h3 class="mb-0">${item.Title}</h3>
                                  </a></div>
                                ${badge}
                                ${rnAuthors(item.Authors)}
                                <p data-ve-gtm="item-date" class="text-util-md mb-2">${liveOn} ${item.FormattedPublishDate}</p>
                                ${rnReadTime(veRelatedMedia.getRelatedMediaType(item.Type), item.Time)}
                                ${mksummary}
                                <div class="grid-card__divider"></div>
                              </div>
                    </div>`;
                case "insights-grid":
                    return `<div class="insights-grid__item col-md-6 col-lg-4">
                              <div data-ve-gtm="${veRelatedMedia.getGtmGridCardAttributeValue(item.Type)}" class="grid-card">
                                ${mkimage}
                                ${mkCategory}
                                <div class="grid-card__header"><a data-ve-gtm="item-title" class="grid-card__title-link" href="${item.MediaLink}">
                                    <h3 class="mb-0">${item.Title}</h3>
                                  </a></div>
                                ${badge}
                                ${rnAuthors(item.Authors)}
                                <p data-ve-gtm="item-date" class="text-util-md mb-2">${liveOn} ${item.FormattedPublishDate}</p>
                                ${rnReadTime(veRelatedMedia.getRelatedMediaType(item.Type), item.Time)}
                                ${mksummary}
                                <div class="grid-card__divider"></div>
                              </div>
                    </div>`;
                case "au-landing-grid":
                    return `<div class="insights-grid__item col-md-6 col-lg-3">
                              <div data-ve-gtm="" class="grid-card">
                                ${mkimage}
                                <div class="grid-card__eyebrow">
                                    ${mkCategory}
                                    ${mkDate}
                                </div>
                                <div class="grid-card__header"><a data-ve-gtm="item-title" class="grid-card__title-link" href="${item.FileUrl}" target="_blank">
                                    <h3 class="mb-0">${item.Title}</h3>
                                  </a></div>
                                ${mksummary}
                                <div class="grid-card__divider"></div>
                              </div>
                    </div>`;
                case "au-insights-grid":
                    return `<div class="insights-grid__item col-md-6 col-lg-4">
                              <div data-ve-gtm="${veRelatedMedia.getGtmGridCardAttributeValue(item.Type)}" class="grid-card">
                                ${mkimage}
                                ${mkCategory}
                                <div class="grid-card__header"><a data-ve-gtm="item-title" class="grid-card__title-link" href="${item.MediaLink}">
                                    <h3 class="mb-0">${item.Title}</h3>
                                  </a></div>
                                ${badge}
                                ${mksummary}
                                <div class="grid-card__divider"></div>
                              </div>
                    </div>`;
                case "au-news-grid":
                    return `<div class="col-lg-4 mb-4">
                                <div class="media-coverage-card card">
                                     <a class="media-coverage-card__toggle" href="${item.Link}">
                                <div class="media-coverage-card__eyebrow">
                                    ${mkDate}
                                    ${mkCategory}
                                </div>
                                ${mkTitle}
                            </a>
                    </div>
                </div>`;
                default:
                    return `<div class="insights-grid__item col-md-6 col-lg-3">
                              <div data-ve-gtm="${veRelatedMedia.getGtmGridCardAttributeValue(item.Type)}" class="grid-card">
                                ${mkimage}
                                ${mkCategory}
                                <div class="grid-card__header"><a data-ve-gtm="item-title" class="grid-card__title-link" href="${item.MediaLink}">
                                    <h3 class="mb-0">${item.Title}</h3>
                                  </a></div>
                                ${badge}
                                ${rnAuthors(item.Authors)}
                                <p data-ve-gtm="item-date" class="text-util-md mb-2">${liveOn} ${item.FormattedPublishDate}</p>
                                ${rnReadTime(veRelatedMedia.getRelatedMediaType(item.Type), item.Time)}
                                ${mksummary}
                                <div class="grid-card__divider"></div>
                              </div>
                    </div>`;
            }
        },

        /***
        * Function to read the query strings and then tune the config of the veRelatedMedia item.
        * */
        configureGridByQueryStrings: () => {
            //debugger;
            //Try to get the mediaType from the URL
            const mediaType = getQueryStringParam("mediaType");
            const category = getQueryStringParam("category");
            if (category) {

                const getCategoryFromString = catString => {
                    const selectedCat = $("#NewsDropdown .dropdown__item").toArray().find(x => {
                        const matchesCategoryName = $(x).text().toLowerCase().replace(/[ ]/g, "-") === catString;
                        const matchesNameInURL = $(x).data("categoryurlname")?.toLowerCase().replace(/[ ]/g, "-") === catString;
                        return matchesCategoryName || matchesNameInURL;
                    });
                    if (selectedCat) {
                        //return Array [categoryName, categoryID];
                        return [$(selectedCat).text(), $(selectedCat).attr("value")];
                    }
                    return [false, false];
                }

                const setCategory = insightsCategory => {
                    //get the Id and name of the category
                    if (typeof insightsCategory != "string") return false;
                    const catString = insightsCategory.toLowerCase();
                    if (!catString) return false;
                    const [catName, catId] = getCategoryFromString(catString);

                    if (!catId || !catName) return;
                    $(".ve-dynamic-related-media:first").data("categoryid", catId).attr("data-categoryid", catId);
                    $("#NewsDropdown .dropdown__label").text(catName);
                }

                setCategory(category);
            }

            if (mediaType) {
                //To set the mediatype to the first item.
                const setType = insightsType => {
                    $(".ve-dynamic-related-media:first").data("insightstype", insightsType).attr("data-insightstype", insightsType);
                    $("#InsightsTypeDropdown .dropdown__label").text(insightsType + "s");
                    insightsType == "All" ? $("#InsightsTypeDropdown .dropdown__label").text("All Formats") : false;
                }

                veRelatedMedia.shouldScrollIntoView = true;

                //we switch so only the relavent ones can be used, all others will be ignored.
                //Also capitalisation of first letter.
                switch (mediaType.toLowerCase()) {
                    case "webinar":
                        setType("Webinar")
                        break;
                    case "blog":
                        setType("Blog")
                        break;
                    case "video":
                        setType("Video")
                        break;
                    case "podcast":
                        setType("Podcast")
                        break;
                    case "all":
                        setType("All")
                        break;
                    default:
                        return false;
                }
            }

            return false;
        },

        scrollIntoView: _ => {
            if (veRelatedMedia.shouldScrollIntoView) {
                //scroll into view
                const rmOffset = $(".ve-dynamic-related-media:first")[0].offsetTop;

                //get category to see if there is a selected category, aka. not a capability page.
                const currentCategory = $(".ve-dynamic-related-media:first").data("category");
                if (rmOffset) { // && !currentCategory) {
                    window.scrollTo(0, rmOffset - 15);
                }
            }
        },

        getSiteContext: name => {
            switch (name) {
                case "Unknown":
                    return 0;
                case "Us":
                    return 1;
                case "Ucits":
                    return 2;
                case "Corp":
                    return 3;
                case "ForeignTax":
                    return 4;
                case "Au":
                    return 5;
                case "Etn":
                    return 6;
                default:
                    return 1;
            }
        },

        /**
         * Init Function that reads all related media components and adds them to an object.
         * Then initialises the items and renders them.
         * */
        init: async (ignoreQueryStrings = false) => {

            if (!ignoreQueryStrings) {
                //readQueryStringParams to see if there is an override.
                veRelatedMedia.configureGridByQueryStrings();
            }

            $(".ve-dynamic-related-media").each((i, e) => {
                //debugger
                var relatedMediaItem = {
                    id: i,
                    element: e,
                    endpoint: $(e).data("endpoint") ?? veRelatedMedia.endpoint,
                    count: $(e).data("count") ?? 8,
                    template: $(e).data("template") ?? "au-landing-grid",
                    siteContext: $(e).data("sitecontext") ?? "",
                    nextPage: 0
                }
                //debugger
                veRelatedMedia.relatedMediaItems.push(relatedMediaItem);

            });

            veRelatedMedia.relatedMediaItems.forEach(async e => {

                $(e.element).find(".view-more").hide().append(`<button data-ve-gtm="read-more" class="insights-grid__button btn btn-primary no-print">${veDictionary.viewMore}</button>`);

                //get the data
                await veRelatedMedia.getData(e);

                //bind the button
                $(e.element).find(".view-more .btn-primary").click(async function () {
                    $(this).attr("disabled", true);
                    await veRelatedMedia.getData(e)
                });
            })
            //wait for half a ms before scrolling into view
            window.setTimeout(x => veRelatedMedia.scrollIntoView(), 200);
            veRelatedMedia.initialised = true;
        }
        /* End of veRelatedMedia */
    }

    veRelatedMedia.init();
})

function convCSDate(dateString) {
    if (typeof dateString != "string") return console.error("Date needs to be string!")
    var date = new Date();
    try {
        date = new Date(dateString.substring(0, 19)); //Cutting off the timezone offset by taking only the first 19 characters
    }
    catch (e) {
        date = new Date(parseInt(dateString.replace(/[^0-9 +]/g, '')));
    }

    var year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    var month = new Intl.DateTimeFormat('en', { month: 'long' }).format(date);
    var day = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(date);

    return `${day} ${month} ${year}`;
}

/**
 * Returns the value of a query string if available or false.
 * @param {any} queryString
 */
function getQueryStringParam(queryString) {
    const queryStrings = window.location.search.replace("?", "").split("&").map(x => x.split("="));
    const results = queryStrings.find(x => x[0]?.toLowerCase() === queryString?.toLowerCase());
    if (results) return results[1];
    return false;
}